import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    paper: {
      width: 580,
      height: "inherit"
    },
    paperScrollPaper: {
      maxHeight: "calc(100% - 180px)",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        maxHeight: "calc(100% - 64px)"
      }
    },
    titleRoot: {
      fontSize: 22,
      padding: "25px 32px",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 18,
        padding: "16px 22px"
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        fontSize: 17,
        padding: "16px 20px"
      }
    },
    contentRoot: {
      overflow: "hidden",
      padding: "8px 32px",
      "&.scrollable": {
        overflowY: "auto"
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        padding: "8px 22px 0"
      },
      [theme.heightBreakpoints.down(400)]: {
        overflow: "auto"
      }
    },
    actionsRoot: {
      justifyContent: "space-between",
      padding: "36px 32px",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        padding: "12px",
        justifyContent: "center",
        gap: 12
      }
    },
    actionButton: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      fontSize: 16,
      padding: "4px 8px",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 14
      }
    },
    backOrCloseButton: {
      color: primary.dark
    },
    submitButton: {
      color: secondary.dark,
      "&.Mui-disabled": {
        color: secondary.dark,
        opacity: 0.5
      }
    }
  };
});
